import { create } from 'zustand';

export type OfferFormState = {
  offer_type: string | null;
  offer_price?: number | null;
  percentage_discount?: number | null;
  from?: number | null;
  to?: number | null;
  buy_quantity?: number | null;
  pay_quantity?: number | null;
  unit_buy?: number | null;
  minimum_quantity?: number | null;
  price_per_unit?: number | null;
};

export type IOfferType = {
  value: string;
  label: string;
  description: string;
};

const offerTypes = [
  {
    value: 'SIMPLE_PRICE',
    label: 'Oferta simples',
    description: 'Defina um preço de oferta padrão para o produto.',
  },
  {
    value: 'SIMPLE_PERCENTAGE',
    label: '% Desconto',
    description: 'Aplique um desconto percentual sobre o preço regular do produto',
  },
  {
    value: 'FROM_TO',
    label: 'De/Por',
    description: 'Comunique o preço regular e o preço de oferta do produto',
  },
  {
    value: 'BUY_PAY_QUANTITY',
    label: 'Leve/Pague',
    description: 'Crie uma promoção por quantidade. Por exemplo, "Leve 3, Pague 2".',
  },
  {
    value: 'BUY_GET_DISCOUNT',
    label: 'Leve/Ganhe',
    description: 'Ofereça um desconto ao comprar uma determinada quantidade de produtos. Por exemplo, "Leve 3 e ganhe 10% de desconto"',
  },
  {
    value: 'UNIT_DISCOUNT',
    label: 'Desconto na 2ªun',
    description: 'Ofereça um desconto no segundo item comprado. Por exemplo, "Compre 1 e o 2º sai com 50% de desconto".',
  },
  {
    value: 'BULK_PERCENTAGE',
    label: 'Desconto no Atacado',
    description: 'Ofereça um desconto ao atingir uma quantidade mínima de itens. Por exemplo, "A partir de 3 unidades, ganhe 10% de desconto"',
  },
  {
    value: 'BULK_PRICE',
    label: 'Oferta no Atacado',
    description: 'Ofereça um preço de oferta ao atingir uma quantidade mínima de itens. Por exemplo, "A partir de 3 unidades, pague R$ 2,99"',
  },
] as const;

export type OfferTypesType = (typeof offerTypes)[number]['value'] | null;

export type OfferTypeValue = Exclude<OfferTypesType, null>;

const OFFER_TYPE_VALUES: ReadonlySet<OfferTypeValue> = new Set(offerTypes.map(item => item.value));

const EDITABLE_FINAL_PRICE_OFFER_TYPES: readonly OfferTypeValue[] = ['SIMPLE_PRICE', 'FROM_TO', 'BULK_PRICE'];
const EDITABLE_DISCOUNT_OFFER_TYPES: readonly OfferTypeValue[] = ['SIMPLE_PERCENTAGE', 'BUY_GET_DISCOUNT', 'UNIT_DISCOUNT', 'BULK_PERCENTAGE'];

export const isOfferTypeValue = (offerType: string | null | undefined): offerType is OfferTypeValue => {
  return typeof offerType === 'string' && OFFER_TYPE_VALUES.has(offerType as OfferTypeValue);
};

export const canEditOfferFinalPrice = (offerType: string | null | undefined): boolean => {
  if (!isOfferTypeValue(offerType)) return false;
  return EDITABLE_FINAL_PRICE_OFFER_TYPES.includes(offerType);
};

export const canEditOfferDiscountPercentage = (offerType: string | null | undefined): boolean => {
  if (!isOfferTypeValue(offerType)) return false;
  return EDITABLE_DISCOUNT_OFFER_TYPES.includes(offerType);
};

type State = {
  offerTypes: IOfferType[];
};

type Actions = {};

const initialState: State = {
  offerTypes: offerTypes.map(item => ({ ...item })),
};

const offerStore = create<State & Actions>(() => ({
  ...initialState,
}));

export const useOfferStore = () => {
  const offerTypes = offerStore(state => state.offerTypes);

  return {
    offerTypes,
  };
};
